"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcuantAlertModelToJSON = exports.AcuantAlertModelFromJSONTyped = exports.AcuantAlertModelFromJSON = void 0;
const _1 = require("./");
function AcuantAlertModelFromJSON(json) {
    return AcuantAlertModelFromJSONTyped(json, false);
}
exports.AcuantAlertModelFromJSON = AcuantAlertModelFromJSON;
function AcuantAlertModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'result': _1.AcuantResultEnumFromJSON(json['result']),
    };
}
exports.AcuantAlertModelFromJSONTyped = AcuantAlertModelFromJSONTyped;
function AcuantAlertModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'result': _1.AcuantResultEnumToJSON(value.result),
    };
}
exports.AcuantAlertModelToJSON = AcuantAlertModelToJSON;
//# sourceMappingURL=AcuantAlertModel.js.map